// 계약 고객 링크(/c/[token]) 화면 문구 — 클라이언트 폼도 읽으므로 서버 전용 모듈을 import 하지 않는다.

export const UNUSABLE_LINK_TITLE = "사용할 수 없는 링크입니다";
export const UNUSABLE_LINK_BODY = "링크가 만료됐거나 더 이상 열 수 없습니다. 계약서를 보낸 시공사에 문의해 주세요.";
export const STATEMENT_UNSIGNED_TITLE = "계약이 체결되면 볼 수 있습니다";
export const STATEMENT_UNSIGNED_BODY = "현재 내역서는 계약을 체결한 뒤에 열립니다. 계약서를 먼저 확인해 주세요.";
export const UNUSABLE_LINK_MESSAGE = "사용할 수 없는 링크입니다. 계약서를 보낸 시공사에 문의해 주세요";

export const CONSENT_LABEL = "위 계약 내용을 확인했고 이에 동의합니다";
export const SIGN_RECORD_NOTICE =
  "체결하면 입력한 이름·체결 시각·접속 정보(IP·브라우저)·문서 해시가 전자적 합의 기록으로 남습니다.";
export const SIGNED_RECORD_NOTICE =
  "아래 계약서는 체결 순간 굳힌 문서입니다. 인쇄하거나 PDF 로 저장해 보관해 주세요.";
export const REVERIFY_MESSAGE = "본인 확인이 풀렸습니다. 휴대폰 뒤 4자리를 다시 입력해 주세요";
export const SIGN_UNAVAILABLE_MESSAGE = "지금은 체결을 처리할 수 없습니다. 잠시 후 다시 시도해 주세요";
